<template>
  <div class="edit-form">
    <el-form ref="form" :model="form" label-width="80px" :rules="rules">
      <el-form-item label="玩家名称" prop="userName">
        <el-input v-model="form.userName" placeholder="请输入玩家名称"></el-input>
      </el-form-item>

      <!-- 
        :http-request="handleUpload"  <-- 拦截上传，我们自己控制
        :file-list="fileList"         <-- 绑定显示列表
      -->
      <el-upload list-type="picture-card" :file-list="fileList" :http-request="handleUpload" :on-remove="handleRemove"
        :on-preview="handlePictureCardPreview">
        <div v-html="uploadsvg"></div>
      </el-upload>

      <el-dialog v-model="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>

      <div class="button-div">
        <el-button type="primary" @click="submitForm" :loading="submitLoading">提交</el-button>
        <el-button @click="close">关闭</el-button>
      </div>
    </el-form>
    <br>
    <br>
    <span v-html="tsTexts"></span>
  </div>
</template>

<script>
import request from '@/utils/request'
import { uploadReportText } from './mainSTconfig'
import { svgRead } from '@/svgIcon/main';

export default {
  name: 'UploadReportPageST',
  props: {
    nameData: {
      type: Object,
      default: () => ({ 'name': null }),
      validator: (value) => {
        return Object.hasOwn(value, 'name');
      }
    }
  },
  data() {
    return {
      form: { userName: "" },
      rules: {
        userName: [
          { required: true, message: '请输入玩家名称', trigger: 'blur' }
        ]
      },
      fileList: [], // 用于前端展示的列表
      dialogImageUrl: '',
      dialogVisible: false,
      submitLoading: false,
      handleUploadState: false,
      tsTexts: uploadReportText,
      uploadsvg: svgRead('upload-a', "rgb(164 164 164)", 50, 50)
    }
  },
  methods: {
    /**
     * 【核心】自定义上传逻辑 (对应 apiA)
     * 这里的逻辑是：先传文件给后端验证，验证通过才显示
     */
    async handleUpload(options) {
      this.handleUploadState = true;
      const { file, onSuccess, onError } = options;
      const rawFile = file; // 原生 File 对象

      const formData = new FormData();
      // 直接把文件丢给后端，让后端算 MD5
      formData.append('file', rawFile);

      try {
        // 1. 调用 apiA (验证接口)
        // 注意：这里我们传的是文件，不是 MD5
        const res = await request.post('/checkUpload', formData, {
          transformRequest: [(data) => data],
          headers: { 'Content-Type': undefined }
        });

        if (res.po) {

          const url = URL.createObjectURL(rawFile);

          // 包装文件对象，存入列表
          const fileItem = {
            name: rawFile.name,
            size: rawFile.size,
            raw: rawFile, // 保存原始文件对象，供提交时使用
            url: url,      // 临时预览链接
            verify: true
          };

          // 手动更新列表
          this.fileList.push(fileItem);

          this.$message.success('图片验证通过');
          onSuccess();
          this.handleUploadState = false;
        } else {
          // 3. 后端验证失败（库里有重复）
          this.$message.warning(res.message || '图片已存在，请勿重复上传');
          onError(new Error('duplicate'));
          this.handleUploadState = false;
        }

      } catch (err) {
        console.error(err);
        this.$message.error(err.response?.data?.message || '上传校验失败');
        onError(err);
        this.handleUploadState = false;
      }
    },
    /**
     * 移除图片
     */
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      if (index > -1) {
        this.fileList.splice(index, 1);
      }
      // 释放临时链接内存
      if (file.url && file.url.startsWith('blob:')) {
        URL.revokeObjectURL(file.url);
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    /**
     * 【核心】提交逻辑 (对应 apiB)
     */
    async submitForm() {
      if (this.handleUploadState) {
        this.$message.warning("请等待图片验证成功后再提交！");
        return;
      }
      if (this.form.userName === "") {
        this.$message.warning('请输入玩家名称');
        return;
      }
      if (this.fileList.length === 0) {
        this.$message.warning('请至少上传一张图片');
        return;
      }
      for (let item of this.fileList) {
        if (!item.verify) {
          this.$message.warning("请等待图片验证成功后再提交！");
          return;
        }
      }
      this.submitLoading = true;

      try {
        const formData = new FormData();
        formData.append('userName', this.form.userName);

        // 将内存中的所有文件 append 进去
        this.fileList.forEach(item => {
          formData.append('files', item.raw);
        });

        // 调用 apiB (保存接口)
        const res = await request.post('/SaveReport', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        if (res.po) {
          this.$message.success(`提交成功！获得积分：${res.response.add_integral}`);
          this.$emit("save", res);
          this.close();
        } else {
          this.$message.error(res.message);
        }

      } catch (error) {
        console.error(error);
        this.$message.error(error.response?.data?.message || '提交失败');
      } finally {
        this.submitLoading = false;
      }
    },

    close() {
      // 清理内存
      this.fileList.forEach(file => {
        if (file.url && file.url.startsWith('blob:')) {
          URL.revokeObjectURL(file.url);
        }
      });
      this.fileList = [];
      this.form.userName = "";
      this.$emit('close');
    }
  },
  beforeUnmount() {
    // window.removeEventListener('copy', this.handleCopy);
  },
  mounted() {
    if (this.nameData.name != null) {
      this.form.userName = this.nameData.name;
      this.isSearch = true;
    }
  }
}
</script>

<style scoped>
.button-div {
  padding-top: 15px;
  display: flex;
  justify-content: flex-end;
}
</style>